import { StatusBadge } from 'components/StatusBadge';
import { set } from 'features/app/appSlice';
import { approvalItemStatus } from 'pages/approvals/config/constants';
import { useGetApprovalItemStats } from 'pages/approvals/hooks/useGetApprovalItemStats';
import { useGetPurposeText } from 'pages/approvals/hooks/useGetPurposeText';
import { useGetBlockApprovalItem } from 'pages/documents_v2/views/edit_area/hooks/useGetBlockApprovalItem';
import { useGetBlockApprovalParticipation } from 'pages/documents_v2/views/edit_area/hooks/useGetBlockApprovalParticipation';
import { idToUri } from 'pages/global/UriHelper';
import { entityTypes } from 'pages/translation/config/Constants';
import { Clipboard2Check, PersonFillCheck } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';

/**
 * @param {import('models/documents.models').Block} block
 */
export function BlockTasks({ block }) {
    const hasTask = block.approvalState === 'pending' || block.approvalState === 'approved';

    if (hasTask) {
        return <TaskStatusBadge block={block} />;
    }

    return null;
}

/**
 * @param {import('models/documents.models').Block} block
 */
function TaskStatusBadge({ block }) {
    const dispatch = useDispatch();
    const { documentId, areaId } = useParams();
    const approvalItem = useGetBlockApprovalItem(block.id, areaId);
    const userTask = useGetBlockApprovalParticipation(block.id, areaId);

    const badgeType = block.approvalState === 'approved' ? 'done' : 'progress';

    return (
        <>
            <StatusBadge variant={badgeType} className="mr-2" tooltip="Bekijk taken" onClick={handleSettingsIconClick}>
                <Clipboard2Check size={14} />
                {approvalItem && <ApprovalItem approvalItem={approvalItem} />}
            </StatusBadge>

            {userTask && <UserBadge userTask={userTask} />}
        </>
    );

    function handleSettingsIconClick() {
        dispatch(
            set({
                key: 'sidebarContext',
                value: {
                    type: 'sidebarSettings',
                    context: {
                        entity: block,
                        entityType: entityTypes.BLOCK,
                        documentId: parseInt(documentId),
                        areaId: parseInt(areaId),
                        uri: idToUri(block.id, entityTypes.BLOCK),
                        parentUri: idToUri(parseInt(documentId), entityTypes.DOCUMENT),
                        landingTab: 'approvals',
                    },
                },
            }),
        );
    }
}

/**
 * @param {import('models/approval.models').ApprovalParticipation} userTask
 */
function UserBadge({ userTask }) {
    const [, setApprovalParticipation] = useQueryParam('ap', StringParam);

    return (
        <StatusBadge
            variant="dark"
            className="mr-2"
            tooltip="Aan jou toegewezen"
            onClick={() => setApprovalParticipation(userTask.id)}
        >
            <PersonFillCheck size={16} />
        </StatusBadge>
    );
}

/**
 * @param {import('models/approval.models').ApprovalItem} approvalItem
 */
function ApprovalItem({ approvalItem }) {
    const itemStats = useGetApprovalItemStats(approvalItem['@id']);
    const purposeText = useGetPurposeText(approvalItem.purpose);

    const total = itemStats?.stats?.total_required_approvals ?? 0;
    const approved = itemStats?.stats?.approved ?? 0;

    return (
        <>
            {purposeText}
            {total > 0 && (
                <div>
                    {approved}&nbsp;/&nbsp;{total}
                </div>
            )}
        </>
    );
}
